export default "__VITE_ASSET__DfEf$grx__"